import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import ROLES from 'config/roles';
import ROUTES from 'config/routes';
import Icon, {ICON_NAMES} from 'components/Icon';
import Preloader from 'components/Preloader';
import ProfileMenu from './ProfileMenu';


const Profile = props => {

  const {first_name, last_name, company_name, contact_name, role, favoriteList} = props;
  const [isOpened, setOpened] = useState(false);

  const handleMenuOpen = (event) => {
    setOpened(true);
  };
  const handleMenuClose = (event) => {
    setOpened(false);
  }

  const isLoading = !company_name && !first_name && !last_name;

  return (
    <div className="header-profile">
      {
        role !== ROLES.COMPANY &&
        role !== ROLES.FACILITY &&
        <Link to={ROUTES.profileFavorites} className="header-profile__favorite">
          <Icon name={ICON_NAMES.favorite} className="icon--favorite"/>
          {
            favoriteList && favoriteList.length > 0 &&
            <span className="header-profile__favorite-counter">{favoriteList.length}</span>
          }
        </Link>
      }
      <div className="header-profile__menu-container">
        <button
          className="header-profile__name-btn"
          onClick={handleMenuOpen}>
          <span className="header-profile__name">
            {
              isLoading
                ? <Preloader/>
                : company_name || `${first_name} ${last_name}`
            }
          </span>
          <Icon
            name={ICON_NAMES.arrowDropdown}
            className="icon--arr-down header-profile__arr-down"/>
        </button>

        <ProfileMenu isOpened={isOpened} onClickOutside={handleMenuClose} role={role}/>
      </div>
    </div>
  )
}

export default Profile;
